import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { rootReducerWithReset } from '.';

const sagaMiddleware = createSagaMiddleware();

interface CustomWindow extends Window {
  __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
}
const composeEnhancers =
  process.env.NODE_ENV === 'development'
    ? ((window as CustomWindow)
        .__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ as typeof compose)
    : null || compose;

const store = createStore(
  rootReducerWithReset,
  composeEnhancers
    ? composeEnhancers(applyMiddleware(sagaMiddleware))
    : applyMiddleware(sagaMiddleware),
);

export default store;
